<template>
  <div
    class="container lms-wrapper no-right-sidebar pd-x-0 pd-lg-x-10 pd-xl-x-0"
  >
    <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <vue-custom-scrollbar :style="`height: ${scrollHeight.nav}px`">
          <div :class="`card ${$store.state.app.isMobile ? 'bd-0' : ''}`">
            <div class="card-body">
              <student-nav @route-changed="toggleNavbar(false)"></student-nav>
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
    <div class="lms-content">
      <div class="lms-content-body">
        <div v-for="(c, i) in courses" :key="`courses_${i}`" class="mg-b-20">
          <div class="d-flex align-items-center justify-content-between mg-b-2">
            <h6 class="tx-13 tx-uppercase tx-semibold mg-b-0">{{ c.name }}</h6>
          </div>
          <ul class="list-group wd-md-50p">
            <li
              @click="deleteAttach(a)"
              v-for="(a, ai) in attaches.filter(x => x.courseId == c.id)"
              :key="ai"
              class="list-group-item d-flex align-items-center"
            >
              <div class="avatar avatar-sm mg-r-5">
                <span class="avatar-initial rounded-circle bg-gray-600">{{
                  a.ext
                }}</span>
              </div>
              <div style="max-width: 80%">
                <h6 class="tx-13 tx-inverse tx-semibold mg-b-0 text-truncate">
                  {{ a.title }}
                </h6>
                <span class="d-block tx-11 text-muted">{{
                  getLessonName(a.lessonId)
                }}</span>
              </div>
              <div class="mg-l-auto">
                <a>
                  <feather type="arrow-right"></feather>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <b-modal
      v-model="attachDelete.modal"
      centered
      :title="attachDelete.obj.title"
      hide-footer
    >
      <div v-if="attachDelete.mode == 1">
        <video id="video2" width="100%" height="240" controls></video>
      </div>
      <div
        v-else-if="attachDelete.mode == 2"
        style="max-width: 100%; overflow: auto; height: 70vh"
      >
        <img id="image2" />
      </div>
      <div v-else-if="attachDelete.mode == 3">
        <!-- <div id="pdf2" style="height: 70vh"></div> -->
        <iframe src="" id="pdf2" />
      </div>
      <div v-else-if="attachDelete.mode == 4"></div>

      <div class="btn-group text-center wd-100p mg-t-20">
        <router-link
          :to="{
            name: 'lmsCourseView',
            params: { id: attachDelete.obj.courseId, bid: 0, iid: 0, bot: 0 }
          }"
          class="btn btn-primary"
          >Сургалтыг үзэх</router-link
        >
        <button @click="attachDelete.modal = false" class="btn btn-light">
          Хаах
        </button>
        <button @click="deleteAttachConfirm()" class="btn btn-danger">
          Устгах
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";

var _ = require("lodash");

import { getFileMode } from "@/libs/tools";
import { mapActions } from "vuex";

import PDFObject from "pdfobject";

export default {
  components: {
    vueCustomScrollbar,
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      PDFJS_URL: "https://res.gosmart.mn/static/pdfobject/web/viewer.html",

      scrollHeight: {
        contentToolbarHeight: 49,
        nav: 0,
        content: 0,
        right: 0
      },

      courses: [],
      lessons: [],
      attaches: [],

      attachDelete: {
        obj: {},
        mode: 0,
        modal: false
      },

      //FILESYSTEM
      fileSystem: null,
      fsType: window.PERSISTENT,
      fsSize: 10000 * 1024 * 1024
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();

    this.configure();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
    this.toggleBodyClass("removeClass", "app-lms");
  },
  destroyed() {
    window.removeEventListener("resize", this.getWindowHeight);
    this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    ...mapActions(["handleOfflineAttaches"]),

    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    getWindowHeight() {
      let contentSub = 120;
      let navSub = 120;
      let rightSub = 120;
      if (screen.width <= 1024) {
        contentSub = 85;
        navSub = 85;
        rightSub = 85;
      }

      contentSub += this.scrollHeight.contentToolbarHeight;
      rightSub += this.scrollHeight.contentToolbarHeight;

      this.scrollHeight.content = window.innerHeight - contentSub;
      this.scrollHeight.nav = window.innerHeight - navSub;
      this.scrollHeight.right = window.innerHeight - rightSub;
    },
    configure() {
      if (
        this.$store.state.app.activeGroup.PDFJS_URL != undefined &&
        this.$store.state.app.activeGroup.PDFJS_URL != ""
      ) {
        this.PDFJS_URL = this.$store.state.app.activeGroup.PDFJS_URL;
      }

      this.init();
    },
    init() {
      let self = this;

      //FILESYSTEM
      window.requestFileSystem =
        window.requestFileSystem || window.webkitRequestFileSystem;
      window.storageInfo = window.storageInfo || window.webkitStorageInfo;

      window.storageInfo.requestQuota(
        self.fsType,
        self.fsSize,
        function(gb) {
          window.requestFileSystem(
            self.fsType,
            gb,
            function(fs) {
              //console.log('1=> ', fs);
              self.fileSystem = fs;
            },
            self.errorHandler
          );
        },
        self.errorHandler
      );

      let _courses = window.localStorage.getItem("off_courses");
      if (_courses) {
        let _json = JSON.parse(_courses);
        this.courses = _json;
      }

      let _lessons = window.localStorage.getItem("off_lessons");
      if (_lessons) {
        let _json = JSON.parse(_lessons);
        this.lessons = _json;
      }

      //let _lessons= window.localStorage.getItem('off_lessons');
      let _attaches = window.localStorage.getItem("off_files");
      if (_attaches) {
        let _json = JSON.parse(_attaches);
        this.attaches = _.orderBy(_json, ["lessonId"], ["desc"]); //.forEach(value => {
        //console.log(value);
        //value.courseName='';
        // Object.assign(value, {
        //   courseName: '',
        //   lessonName: '',
        // });
        //});
        //console.log('2', this.attaches);
      }
    },
    getLessonName(lid) {
      let rv = "";
      if (this.lessons.filter(x => x.id == lid).length) {
        rv = this.lessons.filter(x => x.id == lid)[0].name;
      }
      return rv;
    },
    deleteAttach(a) {
      this.attachDelete.obj = a;
      this.readFile(a.id + "." + a.ext, true, a);
      if (getFileMode(a.ext) == "video") {
        this.attachDelete.mode = 1;
      } else if (getFileMode(a.ext) == "image") {
        this.attachDelete.mode = 2;
      } else if (getFileMode(a.ext) == "pdfObject") {
        this.attachDelete.mode = 3;
      }
      //console.log('this.attachDelete.mode', this.attachDelete.mode);
      this.attachDelete.modal = true;
    },
    readFile(path, success, attachment) {
      let self = this;
      //console.log(this.fileSystem.root)
      this.fileSystem.root.getFile(
        path,
        {},
        function(fileEntry) {
          fileEntry.file(function(file) {
            var reader = new FileReader();

            reader.onloadend = function(e) {
              if (success) {
                self.readAfter(this.result, attachment);
              }
            };
            reader.readAsArrayBuffer(file);
          }, self.errorHandler);
        },
        self.errorHandler
      );
    },

    readAfter(e, attachment) {
      if (attachment.ext == "mp4") {
        var blob = new Blob([e]);
        var video2 = document.getElementById("video2");
        video2.src = URL.createObjectURL(blob);
        video2.load();
        video2.onloadeddata = function() {
          video2.play();
        };
      } else if (attachment.ext == "pdf") {
        //console.log(e);

        //var bloburl = window.URL.createObjectURL(new Blob(binaryData,{type: "application/pdf"})) ;

        var blob = new Blob([e], { type: "application/pdf" });
        var fileURL = window.URL.createObjectURL(blob, {
          type: "application/pdf"
        });

        var pdf2 = document.getElementById("pdf2");
        window.open(fileURL);
        //pdf2.src = fileURL;

        //window.open(fileURL);
        var options = {
          pdfOpenParams: {
            pagemode: "",
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitH"
          },
          page: 1,
          forcePDFJS: true,
          PDFJS_URL: PDFJS_URL
        };
        this.$nextTick(() => {
          PDFObject.embed(fileURL, `#pdf2`, options);
        });
      } else {
        var fileURL = window.URL.createObjectURL(new Blob([e]));
        var image2 = document.getElementById("image2");
        image2.src = fileURL;
      }
    },
    errorHandler(e) {
      var msg = "";
      //console.log('Error: ' + msg+' => '+ e);
    },
    deleteAttachConfirm() {
      let self = this;

      self.fileSystem.root.getFile(
        self.attachDelete.obj.id + "." + self.attachDelete.obj.ext,
        {},
        function(fileEntry1) {
          fileEntry1.remove(function() {
            self.deleteAttachAfter();
          });
        },
        function() {
          //if(self.existsEntryCount!=1){
          //self.onErrorDispAlert();
          //}
        }
      );
    },
    deleteAttachAfter() {
      let i = this.attaches.map(st => st.id).indexOf(this.attachDelete.obj.id);
      this.attaches.splice(i, 1);

      localStorage.setItem("off_files", JSON.stringify(this.attaches));

      if (
        this.attaches.filter(x => x.lessonId == this.attachDelete.obj.lessonId)
          .length == 0
      ) {
        let ci = this.lessons
          .map(st => st.id)
          .indexOf(this.attachDelete.obj.lessonId);
        this.lessons.splice(ci, 1);
        localStorage.setItem("off_lessons", JSON.stringify(this.lessons));
      }

      //console.log('this.courses.filter(x=>x.id==this.attachDelete.obj.courseId).length', this.attaches.filter(x=>x.courseId==this.attachDelete.obj.courseId).length);

      if (
        this.attaches.filter(x => x.courseId == this.attachDelete.obj.courseId)
          .length == 0
      ) {
        let ci = this.courses
          .map(st => st.id)
          .indexOf(this.attachDelete.obj.courseId);
        this.courses.splice(ci, 1);
        localStorage.setItem("off_courses", JSON.stringify(this.courses));
      }
      this.handleOfflineAttaches();

      this.attachDelete.modal = false;
    }
  }
};
</script>
